<template>
  <div
    id="unit_model"
    :style="{
      '--n': options.length >= props.number ? props.number : options.length,
    }"
  >
    <el-scrollbar>
      <template v-if="options.length > 0">
        <div class="unit_box">
          <div
            class="unit_inner"
            :class="{
              active: item[props.fieldNames.value] === props.modelValue,
            }"
            :style="{
              textAlign: props.align,
            }"
            v-for="(item, index) in options"
            :key="index"
            @click="emit('change', item)"
          >
            {{ item[fieldNames.label] }}
          </div>
        </div>
      </template>
      <a-empty v-else></a-empty>
    </el-scrollbar>
    <template v-if="$slots.footer">
      <div class="unit_footer">
        <slot name="footer"></slot>
      </div>
    </template>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: {},
  options: {
    required: true,
    type: Array,
    default: new Array(36),
  },
  fieldNames: {
    type: Object,
    default: {
      label: 'label',
      value: 'value',
    },
  },
  number: {
    type: Number,
    default: 4,
  },
  align: {
    type: String,
    default: 'center',
  },
});
const emit = defineEmits(['change']);
</script>

<style lang="scss">
@import '@/assets/css/mixin.scss';
#unit_model {
  @include boxBordered;
  max-height: 326px;
  position: relative;
  display: flex;
  flex-direction: column;
  .el-scrollbar {
    display: flex;
    flex-direction: column;
  }
  .unit_box {
    display: grid;
    grid-template-columns: repeat(var(--n), 1fr);
  }
  .unit_inner {
    min-width: 86px;
    height: 36px;
    line-height: 36px;
    padding: 0 12px;
    background-color: var(--color_white);
    cursor: pointer;
    position: relative;
    border-right: var(--border_solid_gray);
    border-bottom: var(--border_solid_gray);
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    &:hover,
    &.active {
      background-color: var(--color_brand);
      color: var(--color_white);
      border-color: var(--color_brand);
    }
  }
  .arco-empty {
    grid-column: 1 / calc(var(--n) + 1);
  }
  .unit_footer {
    position: relative;
    &::before {
      content: '';
      position: absolute;
      top: -1px;
      left: 0;
      right: 0;
      height: 1px;
      display: block;
      background-color: var(--color_neutral03);
    }
  }
}
</style>
